import { Injectable } from '@angular/core';
import { CONFIG } from '../../constants/constants';
import { LOG_ELECTRON } from '../../model/eLogElectron';

@Injectable({
  providedIn: 'root'
})
export class LogElectronService {

  private logCount = 0;

  public keyKiosko;

  constructor() {
    this.logCount = 0;
  }

  public saveLog(level:string, evento:string, texto: string){
    localStorage.setItem(LOG_ELECTRON.LEVEL, level);
    localStorage.setItem(LOG_ELECTRON.COUNT, this.logCount.toString());
    localStorage.setItem(LOG_ELECTRON.EVENT, evento);
    localStorage.setItem(LOG_ELECTRON.DATA, texto);
    this.logCount++;
  }

  public getIdKiosko(){
    if(this.keyKiosko == null){
      this.keyKiosko = localStorage.getItem(CONFIG.KEY_KIOSKO);
    }
    
    return this.keyKiosko;
  }
}
